import { QuestionBannerInfoValueType } from '@/hooks/qna/useQuestionDetailViewModel';

type QuestionBannerProps = QuestionBannerInfoValueType & {
  onClickButton: () => void;
};

const QuestionBanner = ({ headText, mainTextRows, buttonText, onClickButton }: QuestionBannerProps) => {
  return (
    <div className="relative flex flex-col gap-5 bg-yellow-100 px-6 py-5">
      <div className="flex flex-col gap-0.5">
        <span className="text-gray-700 typography-ui-15sb">{headText}</span>
        <div className="flex flex-col text-primary-800 typography-ui-24b">
          {mainTextRows.map((text, index) => {
            return <span key={index}>{text}</span>;
          })}
        </div>
      </div>
      <img
        className="absolute bottom-0 right-0 h-[192px] w-[148px]"
        src="/images/qna/bannerPhone.png"
        alt="banner_phone"
      />
      <button
        className="h-10 w-fit rounded-lg bg-primary-600 px-3 text-white typography-ui-15sb"
        onClick={onClickButton}
      >
        {buttonText}
      </button>
    </div>
  );
};

export default QuestionBanner;
